import { Cirus } from "@/classes/Http";
import { AxiosResponse } from "axios";
import { objectToQuery } from "../../ObjectToQuery";

export class GetInventoryResponse {
    protected readonly id: string;
    protected readonly name: string;
    protected readonly inventory_total_value = 0;
    protected readonly inventory_total_sold_value_month = 0;
    protected readonly inventory_total_bought_value_month = 0;
    protected readonly inventory_product_count = 0;
    protected readonly inventory_pure_profit = 0;
    protected readonly inventory_total_sold = 0;
    protected readonly inventory_total_bought = 0;
}

export function getInventories(instance_id: number, params: any = {}): Promise<AxiosResponse<GetInventoryResponse[]>> {
    const query = `/${instance_id}/inventory/all?${objectToQuery(params)}`;
    return Cirus.get(query);
}